export interface CreateNoteForm {
  note?: string;
}

export const createNoteDefaultValueForm: CreateNoteForm = {
  note: undefined,
};
